/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

module.exports = !!('ontouchstart' in global || global.DocumentTouch && document instanceof DocumentTouch);